import { render, staticRenderFns } from "./CreatedPQPage.vue?vue&type=template&id=de30b6ce&"
import script from "./CreatedPQPage.vue?vue&type=script&lang=js&"
export * from "./CreatedPQPage.vue?vue&type=script&lang=js&"
import style0 from "./CreatedPQPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports